import React from "react";
import { HOME_THEME, headingStyle, subHeadingStyle } from "./theme";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "center" | "left";
  onDark?: boolean;
  noMargin?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  align = "center",
  onDark = false,
  noMargin = false,
}) => {
  const titleStyle = {
    ...headingStyle,
    color: onDark ? "#FFFFFF" : HOME_THEME.heroHeading,
    textAlign: align === "center" ? ("center" as const) : ("left" as const),
  };

  const subStyle = {
    ...subHeadingStyle,
    color: onDark ? HOME_THEME.onDarkMuted : HOME_THEME.muted,
    margin: align === "center" ? undefined : 0,
  };

  return (
    <div
      style={{
        textAlign: align,
        maxWidth: align === "center" ? "720px" : "660px",
        margin: noMargin ? 0 : align === "center" ? "0 auto 22px" : "0 0 18px",
      }}
    >
      {eyebrow && (
        <div
          style={{
            color: onDark ? "#5EEAD4" : HOME_THEME.primary,
            fontWeight: 800,
            fontSize: "0.8rem",
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            marginBottom: "8px",
          }}
        >
          {eyebrow}
        </div>
      )}
      <h2 style={titleStyle}>{title}</h2>
      {subtitle && <p style={subStyle}>{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
